var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTable = function SvgTable(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 142,
    viewBox: "0 0 298 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 296,
    height: 140,
    rx: 8,
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H289V35.5H9V9Z",
    fill: "#748FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41.5H74.5V68H9V41.5Z",
    fill: "#E9ECEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 41.5H146V68H80.5V41.5Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 41.5H217.5V68H152V41.5Z",
    fill: "#E9ECEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 41.5,
    width: 65.5,
    height: 26.5,
    fill: "#E9ECEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 74H74.5V100.5H9V74Z",
    fill: "#E9ECEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 74H146V100.5H80.5V74Z",
    fill: "#E9ECEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152 74H217.5V100.5H152V74Z",
    fill: "#E9ECEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 74H289V100.5H223.5V74Z",
    fill: "#E9ECEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106.5H74.5V133H9V106.5Z",
    fill: "#E9ECEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 106.5H146V133H80.5V106.5Z",
    fill: "#E9ECEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152 106.5H217.5V133H152V106.5Z",
    fill: "#E9ECEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 106.5H289V133H223.5V106.5Z",
    fill: "#E9ECEF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk4IiBoZWlnaHQ9IjE0MiIgdmlld0JveD0iMCAwIDI5OCAxNDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIyOTYiIGhlaWdodD0iMTQwIiByeD0iOCIgc3Ryb2tlPSIjQURCNUJEIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjQgNCIvPgo8cGF0aCBkPSJNOSA5SDI4OVYzNS41SDlWOVoiIGZpbGw9IiM3NDhGRkMiLz4KPHBhdGggZD0iTTkgNDEuNUg3NC41VjY4SDlWNDEuNVoiIGZpbGw9IiNFOUVDRUYiLz4KPHBhdGggZD0iTTgwLjUgNDEuNUgxNDZWNjhIODAuNVY0MS41WiIgZmlsbD0iI0U5RUNFRiIvPgo8cGF0aCBkPSJNMTUyIDQxLjVIMjE3LjVWNjhIMTUyVjQxLjVaIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjIyMy41IiB5PSI0MS41IiB3aWR0aD0iNjUuNSIgaGVpZ2h0PSIyNi41IiBmaWxsPSIjRTlFQ0VGIi8+CjxwYXRoIGQ9Ik05IDc0SDc0LjVWMTAwLjVIOVY3NFoiIGZpbGw9IiNFOUVDRUYiLz4KPHBhdGggZD0iTTgwLjUgNzRIMTQ2VjEwMC41SDgwLjVWNzRaIiBmaWxsPSIjRTlFQ0VGIi8+CjxwYXRoIGQ9Ik0xNTIgNzRIMjE3LjVWMTAwLjVIMTUyVjc0WiIgZmlsbD0iI0U5RUNFRiIvPgo8cGF0aCBkPSJNMjIzLjUgNzRIMjg5VjEwMC41SDIyMy41Vjc0WiIgZmlsbD0iI0U5RUNFRiIvPgo8cGF0aCBkPSJNOSAxMDYuNUg3NC41VjEzM0g5VjEwNi41WiIgZmlsbD0iI0U5RUNFRiIvPgo8cGF0aCBkPSJNODAuNSAxMDYuNUgxNDZWMTMzSDgwLjVWMTA2LjVaIiBmaWxsPSIjRTlFQ0VGIi8+CjxwYXRoIGQ9Ik0xNTIgMTA2LjVIMjE3LjVWMTMzSDE1MlYxMDYuNVoiIGZpbGw9IiNFOUVDRUYiLz4KPHBhdGggZD0iTTIyMy41IDEwNi41SDI4OVYxMzNIMjIzLjVWMTA2LjVaIiBmaWxsPSIjRTlFQ0VGIi8+Cjwvc3ZnPgo=";